import React, { useEffect, useState } from 'react';
import { DialogComponent } from '../../../../../Components';
import { PageHeading } from '../../../../../SharedComponents';
import './CallEvaluation.scss';
import { ButtonBase } from '@material-ui/core';
import EvaluationChecklist from './TabsInsight/EvaluationChecklist';
import AgentInsightTab from './TabsInsight/AgentInsightTab';
import { useTranslation } from 'react-i18next';
import { LeadTypeIdEnum } from '../../../../../Enums';

export default function CallEvaluation({
  data,
  onclose,
  parentTranslationPath,
}) {
  const [activeTab, setActiveTab] = useState('evaluation');
  const [isNotEvaluable, setIsNotEvaluable] = useState(false);

  const { t: translate } = useTranslation(parentTranslationPath);

  function checkIfAllValuesNull(data) {
    const nonEventualCall = [
      'Technical Call Interruption',
      'Client Declined Engagement',
      'Unresponsive Call',
    ];
    if (
      !data?.agentPerformanceDetails ||
      nonEventualCall.includes(data.sentimentEvaluation)
    ) {
      setIsNotEvaluable(true);
    } else {
      const allNull = Object.values(data?.agentPerformanceDetails).every(
        (value) => value.value === null
      );
      setIsNotEvaluable(allNull);
    }
  }

  useEffect(() => {
    checkIfAllValuesNull(data);
  }, [data]);

  return (
    <div>
      <DialogComponent
        titleText={'call-analysis'}
        isOpen
        maxWidth={'lg'}
        onCloseClicked={onclose}
        parentTranslationPath={parentTranslationPath}
        dialogContent={
          <div className='call-evaluation-dialog-content'>
            <div className='d-flex-v-center-h-between'>
              <PageHeading
                parentTranslationPath={parentTranslationPath}
                headerTitle={'call-evaluation-dashboard'}
                subTitle={
                  !isNotEvaluable
                    ? 'review-insights,performance,and-call-scoring.'
                    : ''
                }
                wrapperClasses={'w-75'}
                headerTitleClasses={`fz-30 `}
                subTitleClasses={'fz-16 mt-3'}
              />

              <div className='waveform-icon-wrapper'>
                <span class='mdi mdi-waveform waveform-icon'></span>
              </div>
            </div>
            {isNotEvaluable && (
              <div className='alert-banner'>
                ⚠️ Heads up! Category: {data.sentimentEvaluation} —
                <span className='fw-medium'>
                  This call wasn't included in the evaluation.
                </span>
              </div>
            )}
            {/* Metadata Section */}

            <div className='call-meta-section'>
              <div>📞 {data.activity}</div>
              <div>
                👤 {translate('lead')}: {data.lead}
              </div>
              <div>
                📂 {translate('lead-type')}:
                {data.leadType === LeadTypeIdEnum.Owner.leadTypeId
                  ? 'Owner'
                  : 'Seeker'}
              </div>
              <div>
                🧑‍💼 {translate('agent')} : {data.agent}
              </div>
              <div>
                🕒 {translate('duration')} : {data.callDuration}
              </div>
            </div>

            {/* Audio Bar Placeholder */}

            <div className='audio-player-wrapper'>
              <audio controls>
                <source
                  src={data.callAudioFile}
                  type='audio/mpeg'
                />
                <track
                  kind='captions'
                  src='captions.vtt'
                />
                Your browser does not support the audio element.
              </audio>
            </div>

            {/* final-scores */}
            {!isNotEvaluable && (
              <div className='final-scores-wrapper'>
                <div className='final-scores'>
                  <span className='mdi mdi-headphones' />
                  <span className='label-text'>
                    {translate('final-scores')}
                  </span>
                </div>
                <div className='sores-badges-wrapper'>
                  <span className='badge-score score-agent'>
                    {translate('agent-performance')}: {data.agentPerformance}
                  </span>
                  <span className=' badge-score score-lead'>
                    {translate('lead-as-opportunity')}:
                    {data.leadAsOpportunityPer}
                  </span>
                  <span className='badge-score score-sentiment'>
                    {translate('call-evaluation')} : {data.sentimentEvaluation}
                  </span>
                </div>
              </div>
            )}
            {/* Tabs */}
            {!isNotEvaluable && (
              <div className='insight-tabs'>
                <ButtonBase
                  className={activeTab === 'evaluation' ? 'active-tab' : ''}
                  onClick={() => setActiveTab('evaluation')}
                >
                  {translate('evaluation')}
                </ButtonBase>
                <ButtonBase
                  className={activeTab === 'insight' ? 'active-tab' : ''}
                  onClick={() => setActiveTab('insight')}
                >
                  {translate('agent-insight')}
                </ButtonBase>
              </div>
            )}
            <div className='tab-content-wrapper'>
              {activeTab === 'evaluation' && (
                <EvaluationChecklist
                  isNotEvaluable={isNotEvaluable}
                  data={data}
                  translate={translate}
                />
              )}
              {activeTab === 'insight' && (
                <AgentInsightTab
                  data={data}
                  translate={translate}
                />
              )}
            </div>
            {/* Footer */}
            <div
              className={
                !isNotEvaluable
                  ? 'footer-section'
                  : 'footer-section not-evaluable'
              }
            >
              {isNotEvaluable ? (
                <span className='text-muted'>
                  Powered by Laila Al Assistant
                </span>
              ) : (
                <>
                  <div className='text-muted'>
                    Activity Date: 5/24/2025, 12:19:34 PM
                  </div>
                  <span className='badge-category'>
                    {data.sentimentEvaluation}
                  </span>
                  <span className='text-muted'>
                    Powered by Laila Al Assistant
                  </span>
                </>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
}
